import React, { useState, useEffect } from 'react';
import { X, BookOpen, CheckCircle, ArrowRight, Maximize2, Minimize2 } from 'lucide-react';
import api from '../api'; // Assuming 'api' is defined and imported from a file like '../api'

const EnrollmentModal = ({ onClose }) => {
  const [enrollment, setEnrollment] = useState({ diplomatura: '' });
  const [step, setStep] = useState(1);
  const [diplomaturas, setDiplomaturas] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    fetchDiplomaturas();
  }, []);

  const fetchDiplomaturas = async () => {
    try {
      const res = await api.get('diplomas/');
      setDiplomaturas(res.data);
    } catch (err) {
      console.error('Error fetching diplomaturas:', err);
    }
  };

  const handleEnroll = async () => {
    try {
      await api.post(`diplomas/${enrollment.diplomatura}/enroll/`);
      setStep(2);
    } catch (err) {
      console.error('Error in enrollment:', err);
      alert('Hubo un problema al procesar la inscripción. Por favor, intente nuevamente.');
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}>
      <div className={`modal-dialog modal-dialog-centered ${isFullscreen ? 'modal-fullscreen' : ''}`}>
        <div className="modal-content glassmorphism border-0 shadow-lg">
          <div className="modal-header border-0 pb-0 d-flex justify-content-between align-items-center">
            <h5 className="modal-title section-title fs-4 mb-0">
              {step === 1 ? 'Inscripción a Diplomatura' : '¡Inscripción Exitosa!'}
            </h5>
            <div className="d-flex align-items-center gap-2 ms-auto">
              <button
                type="button"
                className="btn-glass p-1 d-flex align-items-center justify-content-center"
                onClick={() => setIsFullscreen(f => !f)}
                title={isFullscreen ? 'Contraer' : 'Ampliar a pantalla completa'}
                style={{ width: '32px', height: '32px', borderRadius: '8px' }}
              >
                {isFullscreen ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
              </button>
              <button
                type="button"
                className="btn-close-premium"
                onClick={onClose}
                aria-label="Close"
              >
                <X size={18} />
              </button>
            </div>
          </div>
          <div className="modal-body p-4 text-center">
            {step === 1 ? (
              <>
                <p className="text-muted mb-4 text-start">Selecciona la oferta académica en la que deseas participar:</p>
                <div className="mb-4 text-start">
                  <label className="form-label small fw-bold text-muted">DIPLOMATURA</label>
                  <select 
                    className="form-select form-select-lg bg-light" 
                    value={enrollment.diplomatura} 
                    onChange={e => setEnrollment({...enrollment, diplomatura: e.target.value})}
                  >
                    <option value="">Seleccione una diplomatura...</option>
                    {diplomaturas.map(d => <option key={d.id} value={d.id}>{d.name} ({d.municipio})</option>)}
                  </select>
                </div>
                <div className="d-grid gap-2">
                  <button 
                    className="btn btn-primary-gradient py-3 fw-bold d-flex align-items-center justify-content-center gap-2"
                    disabled={!enrollment.diplomatura}
                    onClick={handleEnroll}
                  >
                    <BookOpen size={20} /> COMPLETAR INSCRIPCIÓN
                  </button>
                  <button className="btn btn-link text-muted" onClick={onClose}>Cancelar</button>
                </div>
              </>
            ) : (
              <div className="animate-fade-in py-4">
                <h4 className="fw-bold mb-3">Solicitud Enviada</h4>
                <p className="text-muted mb-4">
                  El pedido ya fue elevado y en breve se le dará una devolución por parte de la coordinación académica.
                </p>
                <button className="btn btn-primary-gradient px-5 py-2 fw-bold" onClick={onClose}>
                  VOLVER AL CALENDARIO <ArrowRight size={18} className="ms-2" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrollmentModal;
